import { GridParams } from '@refactor/common';

export class MediaGridParams extends GridParams {
    constructor(params?: Partial<MediaGridParams>) {
        super(params);
    }
}
